import { ReactNode } from 'react';
import { IonSplitPane } from '@ionic/react';
import AutoLogout from '../components/AutoLogout/AutoLogout';
import Navigation from '../components/Navigation/Navigation';
import AppShell from './AppShell/AppShell';
import { getIsMobile } from '../utils/helpers';
import { useCfgParam } from '../hooks/useCfgParam';
import DatasetContextProvider from '../context/DatasetContext/DatasetContext';
import FormTokenChainProvider from '../context/FormTokenChainContext';
import SelectedFiltersContextProvider from '../context/SelectedFiltersContext';
import SelectedRowsContextProvider from '../context/SelectedRowsContext/SelectedRowsContext';
import SlaveDatasetContextProvider from '../context/SlaveDatasetContext';
import DatasetSessionStorageContextProvider from '../context/DatasetSessionStorageContext/DatasetSessionStorageContext';
import ResponseActionsProvider from '../context/ResponseActionsContext';
import KeyboardShortcutsContextProvider from '../context/KeyboardShortcutsContext/KeyboardShortcutsContext';
import RouteTransitionContextProvider from '../context/RouteTransitionContext';
import GuideContextProvider from '../context/GuideContext/GuideContext';
import QuickBookmarksProvider from '../context/QuickBookmarksContext/QuickBookmarksContext';

interface LoggedInLayoutProps {
  children: ReactNode;
}

const LoggedInLayout = ({ children }: LoggedInLayoutProps) => {
  const isMobile = getIsMobile();
  const autoLogoutTime = useCfgParam('loginOptions', 'autoLogout');

  return (
    <ResponseActionsProvider>
      <KeyboardShortcutsContextProvider>
        <DatasetSessionStorageContextProvider>
          <FormTokenChainProvider>
            <DatasetContextProvider>
              <SelectedFiltersContextProvider>
                <SlaveDatasetContextProvider>
                  <SelectedRowsContextProvider>
                    <RouteTransitionContextProvider>
                      <GuideContextProvider>
                        <QuickBookmarksProvider>
                          <IonSplitPane contentId="main" when={false}>
                            {!isMobile && autoLogoutTime && <AutoLogout />}
                            <Navigation />
                            <AppShell>{children}</AppShell>
                          </IonSplitPane>
                        </QuickBookmarksProvider>
                      </GuideContextProvider>
                    </RouteTransitionContextProvider>
                  </SelectedRowsContextProvider>
                </SlaveDatasetContextProvider>
              </SelectedFiltersContextProvider>
            </DatasetContextProvider>
          </FormTokenChainProvider>
        </DatasetSessionStorageContextProvider>
      </KeyboardShortcutsContextProvider>
    </ResponseActionsProvider>
  );
};

export default LoggedInLayout;
